import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { ThemeProvider, applyThemeSync } from "@/lib/theme";
import { migrateLegacyStorage } from "@/lib/legacyMigration";

// Rename any localStorage keys left behind from before the SMIN slug
// rename (Session I-79) so existing users are not logged out.
migrateLegacyStorage();

// Apply persisted theme synchronously BEFORE React renders → no FOLT.
applyThemeSync();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

// Register service worker for offline shell + API caching
import("./lib/registerServiceWorker").then(({ registerServiceWorker }) => registerServiceWorker());
